module.exports = __webpack_public_path__ + "static/media/whatsapp.d3dfd8fa.svg";